module.exports = __webpack_public_path__ + "img/fineness-1.7ea0733.webp";